module.exports = __webpack_public_path__ + "img/lv1.b52aeb92.png";